import { Menu as AntMenu } from "antd";

const Menu = AntMenu;

export default Menu;
